import { Dialog, DialogContent, DialogTitle, Box, Tab, Tabs, Rating, IconButton, Tooltip, FormControl, InputLabel, Select, MenuItem, Grid, SelectChangeEvent } from "@mui/material";
import { Contact } from "../../types/Contact";
import { Actions } from "../../types/Actions";
import { ContactUpdatePayload } from "../../services/connector";
import { EvaluationStatus } from "../../types/Contact";

import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import CommentOutlinedIcon from "@mui/icons-material/CommentOutlined";
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { boardColumns } from "../configuration/boardColumns";
import CvTab from "./tabs/CvTab";
import MotivationLetterTab from "./tabs/MotivationLetterTab";
import ContactTab from "./tabs/ContactTab";
import NotesTab from "./tabs/NotesTab";

export default function ApplicationModal({
    contact,
    tab,
    onClose,
    onTabChange,
    onContactUpdate,
    onContactEvaluationUpdate,
    onContactStatusUpdate,
    onNavigate
}: {
    contact?: Contact;
    tab?: Actions
    onClose: () => void;
    onTabChange: (tab: Actions) => void;
    onContactUpdate: (updatedContact: Contact) => void;
    onContactEvaluationUpdate: (contact: Contact, payload: ContactUpdatePayload) => void;
    onContactStatusUpdate: (contact: Contact, status: EvaluationStatus) => void;
    onNavigate: (next: boolean) => void;
}) {
    const handleContactRatingUpdate = async (e: any, rating: number | null) => {
        await onContactEvaluationUpdate(contact!, { rating });
    }

    const handleContactStatusUpdate = async (e: SelectChangeEvent<EvaluationStatus>) => {
        await onContactStatusUpdate(contact!, e.target.value as EvaluationStatus);
    }

    return (
        <Dialog
            open={contact !== undefined}
            maxWidth="lg"
            fullWidth={true}
            onClose={onClose}
        >
            {contact !== undefined && (
                <>
                    <DialogTitle sx={{ textAlign: "center" }}>
                        Fiche Contact {contact.firstname} {contact.lastname}
                        <Box>
                            <Rating value={contact.evaluation.rating} onChange={handleContactRatingUpdate} />
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={2} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                                <Tooltip title="Candidat précédent">
                                    <IconButton aria-label="Précédent" onClick={() => onNavigate(false)}>
                                        <ArrowBackIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={8}>
                                <FormControl sx={{ width: "100%" }}>
                                    <InputLabel id="application-status">Statut Candidature</InputLabel>
                                    <Select value={contact.evaluation.status} label="Statut Candidature" labelId="application-status" onChange={handleContactStatusUpdate}
                                        sx={{
                                            display: "flex",
                                            "& > .MuiSelect-select": {
                                                display: "flex", alignItems: "center"
                                            },
                                            "& .MuiSvgIcon-root": {
                                                marginRight: 2
                                            },
                                        }}
                                    >
                                        {boardColumns.map(boardColumn =>
                                            <MenuItem key={boardColumn.name} value={boardColumn.status} sx={{
                                                display: "flex", alignItems: "center",
                                                "& > .MuiSvgIcon-root": {
                                                    marginRight: 2
                                                },
                                            }}>
                                                {boardColumn.icon}
                                                {boardColumn.name}
                                            </MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                                <Tooltip title="Candidat suivant">
                                    <IconButton aria-label="Suivant" onClick={() => onNavigate(true)}>
                                        <ArrowForwardIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent>
                        <Box sx={{ width: '100%' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={tab} onChange={(e, selectedTab) => onTabChange(selectedTab)} centered>
                                    <Tab icon={<ContactPageOutlinedIcon />} label="CV" value={Actions.DISPLAY_CV} />
                                    <Tab icon={<ArticleOutlinedIcon />} label="Lettre de motivation" value={Actions.DISPLAY_MOTIVATION_LETTER} />
                                    <Tab icon={<AlternateEmailOutlinedIcon />} label="Messages" value={Actions.DISPLAY_CONTACT} />
                                    <Tab icon={<CommentOutlinedIcon />} label="Notes personnelles" value={Actions.DISPLAY_NOTES} />
                                </Tabs>
                            </Box>
                            {tab === Actions.DISPLAY_CV &&
                                <CvTab contact={contact} />
                            }
                            {tab === Actions.DISPLAY_MOTIVATION_LETTER &&
                                <MotivationLetterTab contact={contact} />
                            }
                            {tab === Actions.DISPLAY_CONTACT &&
                                <ContactTab contact={contact} onContactUpdate={onContactUpdate} />
                            }
                            {tab === Actions.DISPLAY_NOTES &&
                                <NotesTab contact={contact} onContactUpdate={onContactUpdate} />
                            }
                        </Box>
                    </DialogContent>
                </>
            )}
        </Dialog>
    );
}
